<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          topProducts = data
          this.isLoading = false
        }
      "
      contentId="topProducts"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Promotion de produits</div>
      <div>
        <button
          v-if="topProducts.length > 0"
          @click="addNewTopProduct"
          class="buttonComponent"
        >
          Lancer une promotion
        </button>
      </div>
    </div>
    <div v-if="isLoading || topProducts.length > 0">
      <div class="py-4"></div>
      <div class="relative">
        <div class="w-full overflow-auto">
          <div>
            <div
              class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
            >
              <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
                Détails Produit
              </div>

              <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                Position Réservée
              </div>
              <!-- <div class="flex gap-6 w-[5rem] min-w-[5rem]">Réduction</div> -->

              <!-- Price and Quantity -->
              <!-- <div class="flex gap-6 w-[8rem] min-w-[8rem]">Date début</div>

              <div class="flex gap-6 w-[8rem] min-w-[8rem]">Date fin</div> -->
              <!-- SKU -->
              <!-- <div class=" text-gray-700">{{ topProduct.sku }}</div> -->

              <!-- Actions -->
              <div
                class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
              >
                Actions
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div
              v-for="(topProduct, index) in isLoading
                ? shimmerTopProducts
                : topProducts"
              :key="index"
              class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
              :class="{ shimmerElement: topProduct.shimmer }"
            >
              <div
                class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
              ></div>
              <!-- TopProduct Info -->
              <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
                <img
                  v-if="topProduct.image || topProduct.images"
                  :src="topProduct.image || topProduct.images[0]"
                  class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                />
                <div class="w-[16rem]">
                  <h3 class="font-semibold title-color truncate">
                    {{ topProduct.name }}
                  </h3>
                  <p class="truncate">
                    {{ topProduct.description }}
                  </p>
                </div>
              </div>

              <!-- Price and Quantity -->
              <!-- <div class="gap-6 w-[5rem] min-w-[5rem] whitespace-nowrap">
                <div class="title-color font-bold">{{ topProduct.discountedPrice||0 }} FCFA</div>
                <div class="line-through">{{ topProduct.price }} FCFA</div>
              </div> -->

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                <div>Top 10</div>
              </div>

              <!-- Price and Quantity -->
              <!-- <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                {{
                  $Commons.timestampToDate(topProduct.startDate, 'DD MMM YYYY')
                }}
              </div> -->

              <!-- Price and Quantity -->
              <!-- <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                {{
                  $Commons.timestampToDate(topProduct.endDate, 'DD MMM YYYY')
                }}
              </div> -->

              <!-- SKU -->
              <!-- <div class=" text-gray-700">{{ topProduct.sku }}</div> -->

              <!-- Actions -->
              <div
                class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
              >
                <DropdownComponent
                  :selects="[
                    {
                      name: 'Prolonger',
                      onClick() {
                        $Events.dispatchEvent(
                          'new_topproduct_update_required',
                          topProduct,
                        )
                      },
                    },
                    {
                      name: 'Supprimer',
                      onClick() {
                        deleteTopProduct(topProduct)
                      },
                    },
                  ]"
                  hideArrow
                  maxHeight="270px"
                  displayKey="name"
                  toLeft
                  :onSelect="
                    selected => {
                      selected.onClick()
                    }
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                    />
                  </svg>
                </DropdownComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/promotion.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucune promotion effectuée
        </div>
        <div class="py-1"></div>
        <div class="text-lg">
          Faites la promotion de vos produits pour bénéficier d'une meilleure
          visibilité
        </div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <button @click="addNewTopProduct" class="buttonComponent">
            Lancer une promotion
          </button>
        </div>
      </div>
    </div>
    <NewTopProductAdderDialog />
    <TopProductUpdaterDialog />
    <EventListener
      :events="['topproduct_canceled', 'failed_to_cancel_topProduct']"
      @failed_to_cancele_topProduct="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Echec d\'annulation',
            body: 'L\'annulation du topProduct a échoué. Veuillez réessayer',
          })
        }
      "
      @topproduct_canceled="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'TopProduct annulé',
            body: 'Le topProduct a été annulé avec succès.',
          })
        }
      "
    />
  </div>
</template>

<script>
import NewTopProductAdderDialog from '@/components/topProduct/NewTopProductAdderDialog.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    NewTopProductAdderDialog,
    DataGetter,
    DropdownComponent,
    EventListener,
  },
  data() {
    return {
      eventsIds: [],
      topProducts: [],
      isLoading: true,
      shimmerTopProducts: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      activeTab: 'home',
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    addNewTopProduct() {
      this.$Events.dispatchEvent('new_topproduct_adding_required')
    },
    async deleteTopProduct(topProduct) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment Supprimer la réduction pour ${topProduct.name} ?`,
          subTitle: 'Vous ne pouvez plus retrouver ce topProduct',

          successText: 'Supprimer le topProduct',
          cancelText: 'Conserver le topProduct',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('topproduct_deletion_requested', {
        id: topProduct.id,
      })
    },
  },
}
</script>
